import styled, { css } from 'styled-components';

const labelVariants = {
  light: css`
    font-family: ${({ theme }) => theme.FONT.LIGHT};
  `,
  bold: css`
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  `,
  italic: css`
    font-style: italic;
  `,
  inline: css`
    display: inline-block;
  `,
  small: css`
    font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  `,
  base: css`
    font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  `
};

export const StyledLabel = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  ${props => labelVariants[props.variant]}
`;

export const StyledLabelLight = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.FONT.LIGHT};
`;

export const StyledLabelBold = styled(StyledLabel)`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
`;

export const StyledLabelItalic = styled(StyledLabel)`
  font-style: italic;
`;

export const StyledLabelInline = styled(StyledLabel)`
  display: inline-block;
`;

export const StyledLabelSmall = styled(StyledLabel)`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
`;

export const StyledLabelBase = styled(StyledLabel)`
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
`;
